import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

function LogPeriodCard({ femaleCycleDays, dayKey }) {
  const { t } = useTranslation("athlete-portal");
  if (!femaleCycleDays || femaleCycleDays.length === 0) return null;
  const entry = femaleCycleDays.find(
    (d) => d.date === dayKey && d.type !== "predicted"
  );
  if (!entry) return null;
  const dayNum = entry.dayNumber || entry.day || entry.cycleDay;
  const label = t("calendar.cards.period.actual");
  return (
    <div className="log-card log-card--period">
      <div className="log-card__header">
        <SvgIcon src="/img/new-icons/blood-drop-icon.svg" />
        {dayNum
          ? t("calendar.cards.period.dayLabel", { day: dayNum, label })
          : label}
      </div>
    </div>
  );
}

export default LogPeriodCard;
